import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { SuperEmailCertifiedConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';
import {
  getValidationErrorMessage,
  ValidationError,
} from '@modules/campaigns/Domain/Enums/ValidationErrors';

export class SuperEmailCertifiedNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: SuperEmailCertifiedConfig) {
    super(id, NodeType.SuperSendCertifiedEmail, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['copyIds'] === null || this.config['copyIds'].length <= 1;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0) this.childrenNodes.push(node);
    else return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else return;
  }

  initNodeConfig() {
    (this.config as SuperEmailCertifiedConfig).copyIds = [];
    (this.config as SuperEmailCertifiedConfig).certified = true;
    (this.config as SuperEmailCertifiedConfig).super = true;
    (this.config as SuperEmailCertifiedConfig).sendToAllContacts = false;
    (this.config as SuperEmailCertifiedConfig).expirationDays = 180;
    (this.config as SuperEmailCertifiedConfig).expirationAt = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.config['copyIds'] == null) {
      const errorMessage = getValidationErrorMessage(ValidationError.NO_COPY_IDS, {
        nodoType: 'Email Certificado IA',
      });
      errors.push({ nodeId: this.id, errorMessage });
    }

    return errors;
  }
}
